import React, { useState,useEffect  } from 'react';
import {
  Box,
  Button,
  InputBase,
  Typography,
  ThemeProvider,
} from '@mui/material';
import getTheme from '../../theme/theme';
import { BASEURL } from '../../constants/Common';
import axios from 'axios';
import BasicTable, { Column } from '../../components/table';
import { useNavigate } from 'react-router-dom';
import { setSelectedProjectTitle } from '../../store/dailylog/Reducer';
import { useDispatch } from 'react-redux';
import { Backdrop, CircularProgress, } from "@mui/material";
import { safetylogs } from '../safetylogs/Safetylogs';
import { inspections } from '../inspections/Inspections';
import { todolists } from '../todolists/Todolists';
import { vehiclelogs } from '../vehiclelogs/Vehiclelogs';
import { punchlists } from '../punchlists/Punchlists';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';


interface Projects {
  id: number;
  project_name: string;
  project_manager: string;
  project_status: string;
  project_code: string;
  created_by:string;
  // Add other fields as necessary
}

interface WorkOrders {
  issue_tracking_id: number;
  projectname: string;
  createdby: string;
  createddate: string;
  status: string;
  title: string;
  // Add other fields as necessary
}

interface DailyLogs {
  project_id: number;
  title: string;
  status: string;
  assignedto: string;
  projectname: string;
  project_code: string;
  // Add other fields as necessary
}



interface WorkOrders {
  project_id: number;
  title: string;
  status: string;
  assignedto: string;
  projectname: string;
  // project_code: string;
  // Add other fields as necessary
}
interface ServiceTickets {
  project_id: number;
  title: string;
  status: string;
  assignedto: string;
  projectname: string;
  // Add other fields as necessary
}


interface SearchResults {
  projects: Projects[];
  work_orders: WorkOrders[];
  dailylogs: DailyLogs[];
  punchlists:punchlists[];
  todolists:todolists[];
  safetylogs:safetylogs[];
  workorders:WorkOrders[];
  servicetickets: ServiceTickets[];
  inspections:inspections[];
  vehiclelogs:vehiclelogs[];
}

interface ProjectNames {
  id: number;
  project_name: string;
}

const Search: React.FC<{ projectNameList: ProjectNames[] }> = ({ projectNameList }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [selectedLog, setSelectedLog] = useState<DailyLogs | null>(null);
  const [selectedserviceticketLog, setSelectedServiceticketLog] = useState<ServiceTickets | null>(null);
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [selectedWorkorder, setSelectedWorkorder] = useState<WorkOrders | null>(null);
  const [selecteddata, setSelecteddata] = useState<safetylogs | null>(null);
  const [inspectiondata, setSelectedInspectionData] = useState<inspections | null>(null);
  const [todolist, setToDoList] = useState<todolists | null>(null);
  const [vehiclelog, setVehicleLogs] = useState<vehiclelogs | null>(null);
  const [punchlist, setPunchlists] = useState<punchlists | null>(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState<SearchResults>({
    projects: [],
    work_orders: [],
    dailylogs: [],
    punchlists:[],
    todolists:[],
    safetylogs:[],
    servicetickets: [],
    workorders:[],
    inspections:[],
    vehiclelogs:[],
  });
  const [searched, setSearched] = useState(false);

  const organizationId = localStorage.getItem('orgid');
  let orgid: any = null;

  console.log("proj Name", projectNameList)

  if (organizationId) {
    orgid = JSON.parse(organizationId);
  } else {
    navigate('/login');
  }
  
  

  const featuresDetails = localStorage.getItem('featuresDetails');
  let features: any = null;

  if (featuresDetails) {
    features = JSON.parse(featuresDetails);
  } else {
    navigate('/login');
  }

  useEffect(() => {
    
    setProjectNamesData(projectNameList)
  }, []);

  const handleSearch = async () => {
    setSearched(true);
    setResults({
      projects: [],
      work_orders: [],
      dailylogs: [],
      punchlists: [],
      todolists: [],
      safetylogs: [],
      servicetickets: [],
      workorders: [],
      inspections: [],
      vehiclelogs:[],
    });
    setIsLoading(true);
    try {
      // setIsLoading(true);
      const response = await axios.get<SearchResults>(`${BASEURL}/search/`, { params: { q: query, orgid: orgid } });
      setResults(response.data);
      console.log('response.data:', response.data);
    } catch (error) {
      console.error('Error searching:', error);
    }
    finally {
      setIsLoading(false);
    }
  };

  const columns: Column[] = [
    { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'projectmanager', label: 'Project Manager', align: 'left' },
    { id: 'createdby', label: 'Created By', align: 'left' },
    { id: 'projectstatus', label: 'Project Status', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

//   const workorderscolumns: Column[] = [
//     { id: 'projectname', label: 'Project Name', align: 'left' },
//     { id: 'createdby', label: 'Created By', align: 'left' },
//     { id: 'createddate', label: 'Created Date', align: 'left' },
//     { id: 'status', label: 'Status', align: 'left' },
//     { id: 'title', label: 'Title', align: 'left' },
//     { id: 'action', label: '', align: 'left' },
//   ];

  const dailylogscolumns: Column[] = [
    // { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const punchlistscolumns: Column[] = [
    // { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const todolistscolumns: Column[] = [
    // { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const safetylogscolumns: Column[] = [
    // { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const workorderscolumns: Column[] = [
    // { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];
  const serviceticketscolumns: Column[] = [
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];
  const inspectionscolumns: Column[] = [
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const vehiclelogscolumns: Column[] = [
    { id: 'vehicle', label: 'Vehicle', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'purpose', label: 'Purpose', align: 'left' },
    { id: 'createdby', label: 'Createdby', align: 'left' },
    { id: 'assignedto', label: 'Assignedto', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  // const proectname = "akshaya";

  const projectRows = results.projects.map((log, index) => ({
    id: index + 1,
    projectcode: log.project_code,
    projectname: log.project_name,
    projectmanager: log.project_manager,
    createdby: log.created_by,
    projectstatus: log.project_status,
    action: (
      <Button variant='contained' onClick={() => handleProjectViewLog(log)}>
        View
      </Button>
    ),
  }));

  

  const dailylogsRows = results.dailylogs.map((log, index) => {
    //  const correspondingProject = results.projects.find(project => project.id === log.project_id);
    //  const projectName = correspondingProject ? correspondingProject.project_name : '';
  console.log("log:",log);
    return {
      id: index + 1,
    //   projectcode: log.project_code,
      title: log.title,
      projectname: log.projectname,
      status: log.status,
      assignedto: log.assignedto,
      action: (
        <Button variant='contained' onClick={() => handleViewLog(log)}>
          {editMode ? 'View' : 'View'}
        </Button>
      ),
    };
  });

  const punchlistsRows = results.punchlists.map((data, index) => ({
    id: index + 1,
    title: data.title,
      projectname: data.projectname,
      status: data.status,
      assignedto: data.assignedto,
      action: (
        <Button variant='contained' onClick={() => handleViewPunchlist(data)}>
            View
        </Button>
    ),
  }));

  const todolistsRows = results.todolists.map((data, index) => ({
    id: index + 1,
    title: data.title,
      projectname: data.projectname,
      status: data.status,
      assignedto: data.assignedto,
      action: (
        <Button variant='contained' onClick={() => handleViewTodolist(data)}>
            View
        </Button>
    ),
  }));

  const safetylogsRows = results.safetylogs.map((data, index) => ({
    id: index + 1,
    title: data.title,
      projectname: data.projectname,
      status: data.status,
      assignedto: data.assignedto,
      action: (
        <Button variant='contained' onClick={() => handleViewSafetylog(data)}>
            view
        </Button>
    ),
    
  }));

  const workordersRows = results.workorders.map((log, index) => ({
    id: index + 1,
    title: log.title,
      projectname: log.projectname,
      status: log.status,
      assignedto: log.assignedto,
    action: (
      <Button variant='contained' onClick={() => handleworkorderViewLog(log)}>
        View
      </Button>
    ),
  }));


  const serviceticketsRows = results.servicetickets.map((log, index) => ({
    id: index + 1,
    title: log.title,
      projectname: log.projectname,
      status: log.status,
      assignedto: log.assignedto,
    action: (
      <Button variant='contained' onClick={() => handleserviceticketViewLog(log)}>
        View
      </Button>
    ),
  }));

  const inspectionsRows = results.inspections.map((data, index) => ({
    id: index + 1,
    title: data.title,
      projectname: data.projectname,
      status: data.status,
      assignedto: data.assignedto,
      action: (
        <Button variant='contained' onClick={() => handleViewInspection(data)}>
            View
        </Button>
    ),
  }));

  const vehiclelogsRows = results.vehiclelogs.map((data, index) => ({
    id: index + 1,
    // logno: data.logno,
    vehicle: data.vehicle,
    projectname: data.projectname,
    purpose: data.purpose,
    createdby:data.createdby,
    assignedto: data.assignedto,
    // createddate: data.createddate,
    action: (
        <Button variant='contained' onClick={() => handleViewvehiclelogs(data)}>
          View
        </Button>
    ),
}));


  const handleViewSafetylog = (data: safetylogs) => {
    setSelecteddata(data);
    navigate('/safetylog-details', { state: { logDetails: data, projectNamesData: projectNamesData } });
};


  const handleViewLog = (log: DailyLogs) => {
    setSelectedLog(log);
    // Navigate to editlog page to display the selected log details
    //navigate('/log-details');
    console.log("projectNamesData:  in view",projectNamesData);
    navigate('/log-details', { state: { logDetails: log, projectNamesData: projectNameList } });


  };


  const handleProjectViewLog = (log: Projects) => {
    console.log("logproject:",log);
    dispatch(setSelectedProjectTitle(log.id ? log.id.toString() : ''));
    navigate('/projmgmt', { state: { data: log } });
  };

  const handleserviceticketViewLog = (log: ServiceTickets) => {
    setSelectedServiceticketLog(log);
    navigate('/ticket-details', { state: { ticketDetails: log,projectNamesData: projectNamesData } });


  };

  const handleworkorderViewLog = (log: WorkOrders) => {
    setSelectedWorkorder(log);
    navigate('/workorder-details', { state: { workordersDetails: log,projectNamesData: projectNamesData } });


  };
  const handleViewInspection = (data: inspections) => {
    setSelectedInspectionData(data);
    navigate('/inspection-details', { state: { inspectionDetails: data, projectNamesData: projectNamesData } });
};

const handleViewTodolist = (data: todolists) => {
  setToDoList(data);
  navigate('/todolist-details', { state: { todolistDetails: data, projectNamesData: projectNamesData } });
};

const handleViewvehiclelogs = (data: vehiclelogs) => {
  setVehicleLogs(data);
  navigate('/vehiclelog-details', { state: { logDetails: data, projectNamesData: projectNamesData } });
};

const handleViewPunchlist = (data: punchlists) => {
  setPunchlists(data);
  navigate('/punchlist-details', { state: { punchlistDetails: data, projectNamesData: projectNamesData } });
};
  return (
    <ThemeProvider theme={getTheme()}>

<Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Box sx={{ marginTop: '-60px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='h5' component='div'>
            Search
          </Typography>
        </Box>

        <Box sx={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
          <InputBase
            placeholder='Search…'
            inputProps={{ 'aria-label': 'search' }}
            sx={{
              marginRight: '10px',
              border: '1px solid',
              borderRadius: '4px',
              paddingLeft: '10px',
              ml: '5%',
              height: '45px',
            }}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Button variant='contained' onClick={handleSearch}>
            Search
          </Button>
        </Box>
        {searched && (
          <>
            <h2>Results</h2>
            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Project Management</Typography>
              {results.projects.length > 0 ? (
                <BasicTable columns={columns} rows={projectRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            {/* <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Work Orders</Typography>
              {results.work_orders.length > 0 ? (
                <BasicTable columns={workorderscolumns} rows={workOrderRows} />
              ) : (
                <Typography variant='body1'>No records found</Typography>
              )}
            </Box> */}
            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Dailylogs</Typography>
              {results.dailylogs.length > 0 ? (
                <BasicTable columns={dailylogscolumns} rows={dailylogsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Punchlists</Typography>
              {results.punchlists.length > 0 ? (
                <BasicTable columns={punchlistscolumns} rows={punchlistsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            
            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>ToDolists</Typography>
              {results.todolists.length > 0 ? (
                <BasicTable columns={todolistscolumns} rows={todolistsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Safetylogs</Typography>
              {results.safetylogs.length > 0 ? (
                <BasicTable columns={safetylogscolumns} rows={safetylogsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Workorders</Typography>
              {results.workorders.length > 0 ? (
                <BasicTable columns={workorderscolumns} rows={workordersRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box>

            
             <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Service Tickets</Typography>
              {results.servicetickets.length > 0 ? (
                <BasicTable columns={serviceticketscolumns} rows={serviceticketsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box> 

            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Inspections</Typography>
              {results.inspections.length > 0 ? (
                <BasicTable columns={inspectionscolumns} rows={inspectionsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box> 

            <Box sx={{ marginTop: '20px' }}>
              <Typography variant='h6'>Vehiclelogs</Typography>
              {results.inspections.length > 0 ? (
                <BasicTable columns={vehiclelogscolumns} rows={vehiclelogsRows} />
              ) : (
                !isLoading && <Typography variant='body1'>No records found</Typography>
              )}
            </Box> 
          </>
        )}
        <FloatingButton/>
      </Box>
    </ThemeProvider>
  );
}

export default Search;